import React, { useState, useEffect, useRef } from 'react'
import hoistNonReactStatics from 'hoist-non-react-statics'

// 给开发者使用的快捷方法

export function comparePropsToLog(a: any, b: any) {
  function stringify(o: any) {
    try {
      return JSON.stringify(o)
    } catch (e) {
      return `CAN NOT stringify, keys: ${Object.keys(o)}`
    }
  }
  const logs: string[] = []
  if (a !== b) {
    // 只比较一层
    Object.entries(a).forEach(([ak, av]) => {
      if (!(ak in b)) {
        logs.push(`before [${ak}] deleted`)
      } else if (av !== b[ak]) {
        logs.push(
          `[${ak}] changed. before: ${stringify(av)} \t after: ${stringify(
            b[ak]
          )}`
        )
      }
    })
    Object.entries(b).forEach(([bk, bv]) => {
      if (!(bk in a)) {
        logs.push(`after add [${bk}]. ${stringify(bv)}`)
      }
    })
  }
  return logs.join('\n')
}

export function withAnalyzePropChange(prefixText: string) {
  return function <T>(
    Component: React.ComponentType<T>
  ): React.ComponentType<T> {
    const WrappedComponent = (props: any) => {
      const [prevProps, setPrevProps] = useState<any>()
      const renderTimes = useRef(0)
      if (prevProps) {
        console.log(
          `[${prefixText}]`,
          comparePropsToLog(prevProps, props) || `props has no changed`
        )
      }
      if (prevProps !== props) {
        setPrevProps(props)
      }
      useEffect(() => {
        renderTimes.current++
        console.log(`[${prefixText}] render times: ` + renderTimes.current)
      })
      return <Component {...props} />
    }
    hoistNonReactStatics(WrappedComponent, Component)
    return WrappedComponent
  }
}
